import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(private messageService: MessageService) {}

  error(detail: string, summary = 'Erro', life = 7000) {
    this.messageService.add({
      severity: 'error',
      summary,
      detail,
      life,
    });
  }

  warning(detail: string, summary = 'Atenção', life = 7000) {
    this.messageService.add({
      severity: 'warn',
      summary,
      detail,
      life,
    });
  }

  success(detail: string, summary = 'Sucesso', life = 5000) {
    this.messageService.add({
      severity: 'success',
      summary,
      detail,
      life,
    });
  }

  info(detail: string, summary = 'Info', life = 5000) {
    this.messageService.add({
      severity: 'info',
      summary,
      detail,
      life,
    });
  }
}
